import {ReactNode} from "react";

import ErrorPage from "components/pages/errors/common/ErrorPage";

interface INotFoundProps {
    title: string | ReactNode;
    pageTitle: string;
    subtitle?: string | ReactNode;
}

/**
 * @see Error.tsx for similar
 */
export default function NotFound(props: INotFoundProps) {
    return <ErrorPage title={props.title} pageTitle={props.pageTitle} subtitle={props.subtitle} statusCode={404} />;
}
